module.exports = __webpack_public_path__ + "fonts/merriweather-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Merriweather/merriweather-regular-webfont.woff2
// module id = 3434
// module chunks = 0